export default [
  {
    dataField: 'uf',
    caption: 'UF'
  },
  {
    dataField: 'nome',
    caption: 'Nome'
  }
]
